import React from 'react';

const NeededVolume = ({ valid, dwellersCount, gardenArea, setVolume }) => {
  
  if(!valid){
    setVolume(null);
    return <div/>;
  }

  // Dwellers count is not mandatory, so if empty, then 0
  const _dwellersCount = dwellersCount ? dwellersCount : 0;

  // Same stuff as before
  const _gardenArea = gardenArea ? gardenArea : 0;

  // Formula given by client
  const neededVolume = (_dwellersCount * 1400 + _gardenArea  * 10) / 1000;

  setVolume(neededVolume);

  if(neededVolume === 0){
    return <div/>;
  }

  return (
    <div>
      <h3>Potřebné množství dešťové vody</h3>
      <div className="calc-result">{neededVolume.toFixed(1)} m<sup>3</sup></div>
    </div>
  );
}

export default NeededVolume;